/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { EPGImageSliderItem } from '../../../app/shared/epg-image-slider/epg-image-slider.component';
import { LocationModel, RecordBaseModel, WorkflowItemType } from '../record-base.model';
import { getImageSliderFromTaskDatum } from '../../../app/shared/functions';
import { faFileSignature, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

export class SignatureRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faFileSignature;
  itemData?: SignatureRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.SIGNATURE, undefined, geolocation, timestamp);
  }

  fromJson(json: any): RecordBaseModel | undefined {
    if (!json) return;
    let record = new SignatureRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let recordData = Object.create(SignatureRecordData.prototype);
    record.itemData = recordData.fromJson(json);

    return record;
  }
}

export class SignatureRecordData {
  signatureImage: EPGImageSliderItem[];
  signatoryName?: string;

  constructor(signatureImage: EPGImageSliderItem, signatoryName?: string) {
    let image: EPGImageSliderItem[] = [];
    image.push(signatureImage);
    this.signatureImage = image;
    this.signatoryName = signatoryName;
  }

  fromJson(json: any): SignatureRecordData | undefined {
    if (
      !json ||
      !json.signatureImage?.value ||
      (typeof json.signatureImage.value === 'object' && !json.signatureImage.value.image?.value)
    ) {
      return;
    }

    const image: EPGImageSliderItem = getImageSliderFromTaskDatum(
      typeof json.signatureImage.value === 'object'
        ? json.signatureImage.value.image
        : json.signatureImage
    );
    const name = json.signatoryName?.value ?? '';

    return new SignatureRecordData(image, name);
  }
}
